module.exports = "/fast-coin/fonts/proxima-nova-regular.otf";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/fonts/proxima-nova-regular.otf
// module id = 2266
// module chunks = 5